import type { JsonValue } from "./schema.js";

function stableStringifyValue(value: JsonValue): string {
  if (value === null || typeof value !== "object") {
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    return `[${value.map(stableStringifyValue).join(",")}]`;
  }

  const entries = Object.entries(value).sort(([left], [right]) =>
    left.localeCompare(right),
  );
  return `{${entries
    .map(
      ([key, entry]) => `${JSON.stringify(key)}:${stableStringifyValue(entry)}`,
    )
    .join(",")}}`;
}

export function stableStringify(value: JsonValue): string {
  return stableStringifyValue(value);
}

export function checksum(value: JsonValue): string {
  const input = stableStringify(value);
  let hash = 0x811c9dc5;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
}
